// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Z6eacesO6J0xaBZ4zn9VT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OptionTypeChipsDropdown/OptionTypeChipsDropdown.scss
// module id = 1697
// module chunks = 0